<template>
  <v-list>
    <v-list-group>
      <template v-slot:activator>
        <v-list-tile>
          <v-list-tile-content class="list-tile-content">
            <v-list-tile-title>
              地点個別指定
            </v-list-tile-title>
            <v-chip color="green" text-color="white" class="count-icon"
              >{{ customLocationGroups.simulationLocationGroups.length }}
            </v-chip>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <SidebarDeliveryPointSetting
        v-if="!readonly"
        :form="form"
        :simulation-location-groups="customLocationGroups"
      />
      <SidebarGroupList
        :form="form"
        :simulation-location-groups="customLocationGroups"
        @changeIsSelectedPoiLocationGroup="changeIsSelectedPoiLocationGroup"
      />
    </v-list-group>
    <v-list-group>
      <template v-slot:activator>
        <v-list-tile>
          <v-list-tile-content class="list-tile-content">
            <v-list-tile-title>
              地点カテゴリー
            </v-list-tile-title>
            <v-chip color="green" text-color="white" class="count-icon"
              >{{ poiLocationGroups.simulationLocationGroups.length }}
            </v-chip>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <div class="add-group-area">
        <v-btn
          v-if="!readonly"
          @click="onClickAddCategoryGroup"
          small
          color="primary"
          class="group-add-btn"
        >
          <v-icon>add</v-icon><span>追加</span>
        </v-btn>
        <SidebarPoiGroupSettingModal
          v-if="isShowModal"
          :mode="mode"
          :isFetchSimulationPoiLocations="isFetchSimulationPoiLocations"
          @save="save"
          @cancel="isShowModal = false"
        />
      </div>
      <SidebarGroupList
        :form="form"
        :simulation-location-groups="poiLocationGroups"
        @changeIsSelectedPoiLocationGroup="changeIsSelectedPoiLocationGroup"
      />
    </v-list-group>
  </v-list>
</template>

<script>
import SidebarGroupList from '@/components/Shared/Simulation/SimulationContentDeliverySidebarGroupList'
import SidebarDeliveryPointSetting from '@/components/Shared/Simulation/SimulationContentDeliverySidebarDeliveryPointSetting'
import SidebarPoiGroupSettingModal from '@/components/Shared/Simulation/SimulationContentDeliverySidebarPoiGroupSettingModal'
import { mapActions } from 'vuex'
import {
  SimulationPoiLocationGroup,
  makeTemporaryId,
} from '@/models/Simulation'

export default {
  name: 'SimulationContentDeliverySidebarLocationGroupList',
  components: {
    SidebarGroupList,
    SidebarDeliveryPointSetting,
    SidebarPoiGroupSettingModal,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowModal: false,
      isFetchSimulationPoiLocations: false,
    }
  },
  computed: {
    menuSetting() {
      return this.form.deliverySetting.menuSetting
    },
    customLocationGroups() {
      return this.form.deliverySetting.menuSetting
        .simulationCustomLocationGroups
    },
    poiLocationGroups() {
      return this.form.deliverySetting.menuSetting.simulationPoiLocationGroups
    },
    radius() {
      return this.form.deliverySetting.menuSetting.enableBulkSetting
        ? this.form.deliverySetting.menuSetting.radius
        : SimulationPoiLocationGroup.DEFAULT_RADIUS
    },
    mode() {
      return {
        type: 'create',
        text: '登録',
      }
    },
  },
  methods: {
    ...mapActions('simulation', {
      deselectGroup: 'DESELECT_GROUP',
    }),
    async onClickAddCategoryGroup() {
      this.deselectGroup()
      this.isShowModal = true
    },
    async save(poiSearchForm) {
      const poiLocationGroup = {
        id: makeTemporaryId(),
        name: poiSearchForm.name,
        radius: this.radius,
        added: true,
        ...poiSearchForm,
      }
      try {
        this.isFetchSimulationPoiLocations = true
        await this.poiLocationGroups.addGroup(poiLocationGroup)
        this.isFetchSimulationPoiLocations = false
        this.isShowModal = false
      } catch (e) {
        this.isFetchSimulationPoiLocations = false
      }
    },
    changeIsSelectedPoiLocationGroup(status) {
      this.$emit('changeIsSelectedPoiLocationGroup', status)
    },
  },
}
</script>

<style scoped lang="scss">
.list-tile-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.count-icon {
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
}

.add-group-area {
  border-bottom: 1px solid #d5d5d5;
}

.group-add-btn {
  width: 37%;
}

/* vuetify override */
.v-list {
  padding: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
::v-deep .v-list__tile {
  padding: 0;
  padding-left: 16px;
}
::v-deep .v-list__group {
  flex-grow: 0;
}
::v-deep .v-list__group--active {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
::v-deep .v-list__group__header {
  background-color: #eee;
  &:hover {
    background-color: #ddd;
  }
}
::v-deep .v-list__group__items {
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>
